import React, { useEffect, useState } from "react";
import { ReactComponent as LeftArrow } from "../../../../../assets/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../../assets/arrow-left-dark.svg";
import { Link, useNavigate } from "react-router-dom";
import { useStateContext } from "../../../../../contexts/ThemeContext";
import { toast } from "react-hot-toast";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { gettingLinkList } from "../../../../../redux/slices/gettingLinksList/gettingLinkListSlice";
import ImageForm from "../forms/ImageForm";
import useLocales from "../../../../../hooks/useLocales";
import useSettings from "../../../../../hooks/useSettings";

const Image = () => {
  const { darkMode } = useSelector((state) => state.theme);

  const { translate } = useLocales();
  const { themeDirection } = useSettings();
  const { setActiveMainPageNav } = useStateContext();

  const [imageLoading, setImageLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setActiveMainPageNav(true);

    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const blockFeature = useSelector(
    (state) => state?.paymentStripes?.getBlockByPlanId?.response
  );
  const paymenetBlocks = useSelector(
    (state) => state?.paymentStripes?.getBlockByPlanId?.paymenet_blocks
  );
  // Image
  const imageCheck = blockFeature?.some(
    (item) => item.name === "image" && paymenetBlocks === 1
  );
  useEffect(() => {
    if (!imageCheck) {
      navigate("/pricing");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_API_URL;

  const submitHandler = async (formData) => {
    const linkid = localStorage.getItem("linkId");
    const { token } = JSON.parse(localStorage.getItem("user"));
    const userID = JSON.parse(localStorage.getItem("user")).userid;
    const path = `/api/user/createImageBlock`;
    const url = baseUrl + path;
    const data = {
      coloum_name: "image",
      coloum_type: "image",
      picture: formData?.image,
      link_id: linkid,
      user_id: userID,
      altDescription: formData?.altDescription,
      language: formData?.language,
    };
    if (formData.description) {
      data.description = formData.description;
    }
    if (formData?.url && !/^(http|https):\/\//i.test(formData?.url)) {
      data.url = "https://" + formData?.url;
    } else {
      if (formData?.url && /^(http|https):\/\//i.test(formData?.url)) {
        data.url = formData?.url;
      }
    }
    if (!data.picture) {
      toast.error("Select a Image");
      return;
    }
    setImageLoading(true);
    try {
      const response = await axios.post(url, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `'Bearer ' ${token}`,
        },
      });
      setImageLoading(false);
      const status = response?.data?.status;
      const message = response?.data?.message;
      if (status === "success") {
        toast.success(message);
        setImageLoading(false);
        navigate("/dashboard");
      }
      if (status === "failed") {
        toast.error(message);
        setImageLoading(false);
      }
    } catch (error) {
      console.log("");
    }
    fetchingLinksList();
    setImageLoading(false);
  };

  //  fetching link list after submiting, so list become refresh
  const fetchingLinksList = () => {
    // data need for fetching link list
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user.userid;
    const usertoken = user.token;
    const linkId = localStorage.getItem("linkId");
    const linkListData = {
      userId,
      usertoken,
      linkId,
    };
    dispatch(gettingLinkList(linkListData));
  };

  return (
    <>
      <div className="px-6 md:px-0 mt-[37px] md:mt-0 flex items-center justify-between">
        <Link to={"/dashboard/component"}>
          <div className="flex text-body_copy2 items-center cursor-pointer gap-2 text-heading_color">
            <div>
              {darkMode ? (
                <LeftArrowDark
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              ) : (
                <LeftArrow
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              )}
            </div>
            <p className="dark:text-color_v1_dark">{translate("image")}</p>
          </div>
        </Link>
      </div>
      <ImageForm
        formType="add"
        submitHandlerParent={submitHandler}
        isLoading={imageLoading}
      />
    </>
  );
};

export default Image;
